<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo-flexcash-white.png"
				alt="App-Logo"
				class="is-logo-white" />
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-black" />
		</div>

		<div class="public-center-wrapper">
			<div class="public-wrapper">
				<h2 class="public-msg">
					{{ 'login.msg' | translate }}
				</h2>
				<div class="public-wrapper-container">
					<div class="public-wrapper-content simple-card">
						<form
							#form="ngForm"
							name="formLogin"
							class="public-form"
							(submit)="login($event)">
							<eif-custom-input
								#usernameInput
								[(ngModel)]="username"
								[name]="'username'"
								[label]="'login.username' | translate"
								[autoComplete]="'username'"
								[autoFocus]="true"
								(valueChange)="onUsernameChange($event)"
								(validationChange)="onUsernameValidationChange($event)"
								[required]="true">
							</eif-custom-input>

							<eif-custom-input
								#passwordInput
								[(ngModel)]="password"
								[name]="'password'"
								[type]="'password'"
								[label]="'login.password' | translate"
								[autoComplete]="'current-password'"
								(valueChange)="onPasswordChange($event)"
								(validationChange)="onPasswordValidationChange($event)"
								[required]="true">
							</eif-custom-input>

							<eif-custom-button
								[type]="'submit'"
								[text]="'login.submit' | translate"
								[loading]="isSubmitting"
								[disabled]="isSubmitting"
								[fullWidth]="true"
								[class]="'mt-3'">
							</eif-custom-button>
						</form>

						<div class="public-links-area-helpers">
							<a
								[routerLink]="['/public/recover-password']"
								class="is-hyperlink">
								{{ 'login.can.not.login' | translate }}
							</a>
							<!--Contact Support-->
							<a
								href="mailto:{{ 'help.email.support.email' | translate }}"
								class="is-hyperlink is-contact">
								{{ 'help.email.support' | translate }}</a
							>
						</div>

						<div class="public-browsers-helper">
							<p>{{ 'supported.browsers.warning' | translate }}</p>
							<div class="public-browsers-logos">
								<img
									class="is-grayscale"
									src="assets/images/logo-browser-chrome.svg"
									alt="chrome browser" />
								<img
									class="is-grayscale"
									src="assets/images/logo-browser-firefox.svg"
									alt="chrome browser" />
								<img
									class="is-grayscale"
									src="assets/images/logo-browser-edge.svg"
									alt="chrome browser" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
